module.exports = __webpack_public_path__ + "static/matiaswork3-4d3a978651a3808db0a78cdf79895e6d.jpg";